export default "__VITE_ASSET__7346f70d__"